var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlacierIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "39px",
    viewBox: "0 0 33 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homeowner-mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator-results",
    transform: "translate(-292.000000, -360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(293.000000, 361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.392857, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "premiumIcon",
    fill: "currentColor",
    points: "0.184186083 14.8931755 0.0860557245 17.5753542 3.25075978 21.2821058 5.03972222 27.8363781 7.66873418 29.8304637 8.27304086 34.0047451 12.6616912 35.1437856 15.0041701 37.9726308 18.9004437 25.9083006 22.6583381 27.0877508 22.1329957 20.1646387 24.3778235 14.8931755"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#FFFFFF",
    points: "0.289407893 14.8785249 3.24635158 8.6357782 5.46405935 11.3852528 6.11378966 6.87304264 7.89738558 3.61788232 10.0840443 3.12491527 12.5635608 0.025598224 16.7404258 8.21622492 18.0027042 6.51064262 24.3202294 14.8785249"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    className: "premiumIcon",
    fill: "currentColor",
    points: "12.0700341 0.93119577 12.6158842 8.84265693 16.4937583 14.9987883 24.3620114 14.9987883 18.0012668 6.52505169 17.7073549 10.1349648 12.5177538 0.0824295011"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    className: "premiumIcon",
    fill: "currentColor",
    points: "4.05091319 9.49656758 5.67868885 6.42574668 6.0300032 6.89488646 5.354782 11.2047258"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.113095238,
    y1: 14.915,
    x2: 30.875,
    y2: 14.915,
    id: "Line",
    className: "premiumIcon",
    fill: "currentColor",
    strokeLinecap: "square"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlacierIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/glacier_icon.2e8c6cb363e7f1b219924070e738491a.svg";